import Cookies from "js-cookie";

export class CookieService {
  cookiesAccepted: boolean;

  constructor() {
    // this.cookiesAccepted = this.getCookie('cookies_accepted') === '1';
    // is allowed as it is only used for the CDC screens which is essential and does not need user consent
    this.cookiesAccepted = true;
  }

  /* ====================================================
                  Basic Functionality
    ==================================================*/

  /**
   * Returns string[] of allowed CookieName
   * @returns {string[]}
   */
  get cookieList(): string[] {
    return ["cookies_accepted"];
  }

  /**
   * returns true, if cookies were accepted by the user
   * @returns {boolean}
   */
  get cookiesAllowed(): boolean {
    if (!this.cookiesAccepted) console.warn("Cookies not alled yet");

    return this.cookiesAccepted;
  }

  /**
   * sets Cookie, if User alloed Cookies
   * @param {string} cookieName
   * @param {string} cookieValue
   * @param {number|null} [expiresIn=365] days until the cookie expires...defaults to 365. set null for session cookies
   */
  setCookie(cookieName: string, cookieValue: string, expiresIn: number | null | undefined = 365): void {
    if (!this.cookiesAllowed) return;
    // converting `null` to `undefined` because the type declaration of js-cookie expects number or undefined
    // although in the implementation, any falsy values will mean no concrete expiration date and therefore it is set as a session cookie
    if (expiresIn === null) expiresIn = undefined;

    Cookies.set(cookieName, cookieValue, { expires: expiresIn });
    window.dispatchEvent(
      new CustomEvent("fra-cookie-change", {
        detail: {
          cookieName,
          cookieValue,
        },
      }),
    );
  }

  /**
   * returns value of specific Cookie
   * @param {string} cookieName
   * @returns {string | undefined}
   */
  getCookie(cookieName: string): string | undefined {
    return Cookies.get(cookieName);
  }

  /**
   * returns, whether as specific cookie is set
   * @param {string} cookieName
   * @returns {boolean}
   */
  isCookieSet(cookieName: string): boolean {
    return this.getCookie(cookieName) !== undefined;
  }

  /**
   * returns, whether as cookie has a specific value set
   * @param {string} cookieName
   * @param {string} cookieValue
   * @returns {boolean}
   */
  isCookieValueSet(cookieName: string, cookieValue: string): boolean {
    return this.getCookie(cookieName) === cookieValue;
  }

  /**
   * removes cookie with the given name from documents cookie
   *
   * @param {string} cookieName
   */
  removeCookie(cookieName: string) {
    Cookies.remove(cookieName);
  }

  /**
   * allows Service to set Cookies
   */
  allowCookies(): void {
    if (this.cookiesAccepted) return;

    this.cookiesAccepted = true;
    this.setCookie("cookies_accepted", "1");

    if (window._satellite) {
      window._satellite.setCookie("sat_track", "true", 365 * 2);
      this.reloadDTM();
    }
  }

  /**
   * reloads DTM script dynamicly, by readding it to the DOM
   */
  reloadDTM(): void {
    const dtmScript = document.querySelector("#dtm");

    if (dtmScript === null) return;

    const reloadedScript = document.createElement("script");
    reloadedScript.src = dtmScript.getAttribute("src") || "";

    reloadedScript.addEventListener("load", this.dtmLoaded.bind(this));

    document.head.appendChild(reloadedScript);
  }

  /**
   * Handles DTM-Script reload, by calling _satellite.pageBottom-method
   */
  dtmLoaded(): void {
    if (window._satellite) {
      window._satellite.pageBottom();
    }
  }
}

const CookieServiceInstance = new CookieService();

window._fraCookieService = CookieServiceInstance;

export default CookieServiceInstance;
